/**
 * Citation card - expandable evidence source
 */

import React, { useState } from 'react';
import { ChevronDown, ChevronRight, FileText } from 'lucide-react';
import { Citation } from '../../types/api';
import { clsx } from 'clsx';

export interface CitationCardProps {
  citation: Citation;
}

export function CitationCard({ citation }: CitationCardProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="border border-gray-200 rounded-lg bg-gray-50 overflow-hidden">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between p-3 text-left hover:bg-gray-100 transition-colors"
      >
        <div className="flex items-center gap-2 flex-1">
          {isExpanded ? (
            <ChevronDown className="h-4 w-4 text-gray-500" />
          ) : (
            <ChevronRight className="h-4 w-4 text-gray-500" />
          )}
          <FileText className="h-4 w-4 text-gray-500" />
          <span className="text-sm font-medium text-gray-700">[Source {citation.id}] {citation.source}</span>
        </div>
        
        {citation.confidence !== undefined && (
          <span className="text-xs text-gray-500">
            {(citation.confidence * 100).toFixed(0)}%
          </span>
        )}
      </button>

      {isExpanded && (
        <div className="px-3 pb-3 text-sm text-gray-600">
          {citation.section_path && (
            <p className="text-xs text-gray-500 mb-2">Section: {citation.section_path}</p>
          )}
          {citation.page && (
            <p className="text-xs text-gray-500 mb-2">Page: {citation.page}</p>
          )}
          <p className="mt-2 p-3 bg-white rounded border border-gray-200">
            {citation.content}
          </p>
        </div>
      )}
    </div>
  );
}


